import { IApplicationState } from '../../types/redux/store';

export const isOpenSelector = (state: IApplicationState): boolean => {
  return state.consultantCianChat.isOpened;
};
